import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02394454"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OCriarEventoPlanejado__Atividades" }
const _hoisted_2 = { for: "projetos" }
const _hoisted_3 = { for: "lanca-atividade" }
const _hoisted_4 = { class: "OCriarEventoPlanejado__Conteudo" }
const _hoisted_5 = {
  key: 1,
  class: "OCriarEventoPlanejado__Etapas"
}
const _hoisted_6 = {
  key: 2,
  class: "OCriarEventoPlanejado__SemAtributos"
}
const _hoisted_7 = {
  key: 0,
  class: "OCriarEventoPlanejado__Profissionais",
  "data-testid": "OCriarEventoPlanejado__Profissionais"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-user" }, null, -1))
const _hoisted_9 = { class: "OCriarEventoPlanejado__Periodo" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-clock" }, null, -1))
const _hoisted_11 = { class: "OCriarEventoPlanejado__DataFim" }
const _hoisted_12 = {
  key: 0,
  class: "OCriarEventoPlanejado__SeletorSemanal"
}
const _hoisted_13 = {
  key: 3,
  class: "OCriarEventoPlanejado__ComAtributos"
}
const _hoisted_14 = { class: "OCriarEventoPlanejado__Footer" }
const _hoisted_15 = {
  key: 1,
  class: "OCriarEventoPlanejado__BotoesDeAcao"
}

import { computed, ComputedRef, onMounted, onUnmounted, reactive, Ref, ref } from "vue"
  import Dialog from "primevue/dialog"
  import AButton from "primevue/button"
  import {
    MDropdown,
    MCalendario,
    MEntradaNumerica,
    MMultiSelect,
    AEtapas,
  } from "@/components/Gerais"
  import { EntidadeGenerica } from "@/types/gerais"
  import CalendariosDasAtividadesRepositorio from "@/repositorios/calendarios/calendarios.repositorio"
  import AtividadesPlanejadasRepositorio from "@/repositorios/eventos/eventos.repositorio"
  import { CriarCalendarioDaAtividade } from "@/repositorios/calendarios/calendarios.modelos"
  import ProfissionalRepositorio from "@/repositorios/profissional/profissional.repositorio"
  import TiposDeAtividadeRepositorio from "@/repositorios/tiposDeAtividade/tiposDeAtividade.repositorio"
  import {
    ListarProfissionais,
    ParamsProfissional,
  } from "@/repositorios/profissional/profissional.modelo"
  import {
    ParamsTiposDeAtividade,
    ListarTiposDeAtividadeComAtributos,
  } from "@/repositorios/tiposDeAtividade/tiposDeAtividade.modelo"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { useVuelidate } from "@vuelidate/core"
  import {
    and,
    helpers,
    minLength,
    required,
    requiredIf,
  } from "@vuelidate/validators"
  import { estados } from "@/types/api"

  import { Erro } from "@/repositorios/erros"
  import { ProjetoRepositorio } from "@/repositorios/projeto/projeto.repositorio"
  import {
    ListarProjetos,
    ParamsProjeto,
    ProjetosComAtividadesDoProjeto,
  } from "@/repositorios/projeto/projeto.modelo"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"
  import {
    EscritorErro,
    usarEscritorDeDados,
  } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { CriarAtividadePlanejada } from "@/repositorios/eventos/eventos.modelo"
  import { OSeletorSemanal, ABotaoDeAcao } from "@/components/Calendario"
  import { MFormularioAtividadeComAtributos } from "@/components/Atributos"
  import { usarBuscarMaisDados } from "@/composable/UsarBuscarMaisDados/usarBuscarMaisDados"
  import { useI18n } from "vue-i18n"
  import { Etapa } from "@/components/Gerais/AEtapas/AEtapas.modelos"
  import { CaracteristicaStore } from "@/store/atributos/caracteristicas/caracteristicas.store"
  import { storeToRefs } from "pinia"
  import { AtributoBase } from "@/repositorios/atributos/atributos.modelos"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { CaracteristicaComValor } from "@/components/AtributoComValor/index.interfaces"

  /* interfaces */
  interface Props {
    visible: boolean
    destinos?: string
    modo: "criar" | "editar"
    idEvento?: string
    listaDeAtributosCaracteristicaComValor?: CaracteristicaComValor[]
  }

  interface EmitirVisibilidade {
    (event: "update:visible", visible: boolean): void
    (event: "onRecarregarAtividades"): void
  }

  interface OpcaoAtividadeDoProjeto extends EntidadeGenerica {
    idTipoDeAtividade: string
  }
  /* props */
  
export default /*#__PURE__*/_defineComponent({
  __name: 'OCriarEventoPlanejado',
  props: {
    visible: { type: Boolean },
    destinos: null,
    modo: { default: "criar" },
    idEvento: null,
    listaDeAtributosCaracteristicaComValor: null
  },
  emits: ["update:visible", "onRecarregarAtividades"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:visible", visible: boolean): void
    (event: "onRecarregarAtividades"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, destinos?: string, modo: "criar" | "editar", idEvento?: string, listaDeAtributosCaracteristicaComValor?: CaracteristicaComValor[] }

  

  const { t } = useI18n()

  /* emitters */
  
  const emissorVisibilidade = computed({
    get() {
      return props.visible
    },
    set(visible: boolean) {
      emitir("update:visible", visible)
    },
  })
  /* dados */
  const repeticoes = [
    { id: "nao-repete", nome: t("naoRepete") },
    { id: "semanalmente", nome: t("repeteSemanalmente") },
    // { id: 'diario', nome: 'Diário' },
  ]
  const {
    pegarDataDeHoje,
    obterTimeZoneLocal,
    adicionarHorasNoMomentoAtual,
    pegarSomenteData,
    pegarSomenteAsHoras,
    hoje,
  } = usarDataHora()

  const periodo = reactive({
    inicio: {
      data: pegarDataDeHoje(),
      hora: pegarDataDeHoje(),
    },
    fim: {
      data: adicionarHorasNoMomentoAtual(1),
      hora: adicionarHorasNoMomentoAtual(1),
    },
  })

  const { verificarSeElementoTemConteudo } = usarManipuladorObjetos()
  const { leitor } = usarLeitorDeDados()
  const { escritor, resolver } = usarEscritorDeDados()
  const { onErro, onSucesso, onInfo } = usarMensagemUsuario()
  const caracteristicaStore = CaracteristicaStore()
  const { caracteristicas } = storeToRefs(caracteristicaStore)
  const { verificarPermissao } = usarPermissionamento("Eventos")
  const { atualizarDadosDoRepositorio } = usarBuscarMaisDados()

  const calendarioRep = new CalendariosDasAtividadesRepositorio({
    utilizaCache: true,
  })

  const atividadesPlanejadasRep = new AtividadesPlanejadasRepositorio({ utilizaCache: true })
  const projetoRep = new ProjetoRepositorio({ utilizaCache: true })
  const profissionalRep = new ProfissionalRepositorio({ utilizaCache: true })
  const tiposDeAtividadeRep = new TiposDeAtividadeRepositorio({
    utilizaCache: true,
  })

  const lerProjetos = leitor<ListarProjetos, ParamsProjeto>(
    projetoRep.listarProjetosFrontend,
    {
      ativo: "igual.true",
      "por-pagina": 30,
    }
  )
  const lerTiposDeAtividadeComAtributos = leitor<
    ListarTiposDeAtividadeComAtributos,
    ParamsTiposDeAtividade
  >(tiposDeAtividadeRep.listarTiposDeAtividadeFrontend)
  const lerProfissionais = leitor<ListarProfissionais, ParamsProfissional>(
    profissionalRep.listarProfissionaisFrontend,
    {
      ativo: "igual.true",
    }
  )

  const criarAtividadePlanejadaEscritor = escritor<
    { id: string },
    CriarAtividadePlanejada
  >(atividadesPlanejadasRep.criarAtividadePlanejada, [])
  const criarCalendarioDaAtividadeEscritor = escritor<
    { id: string },
    CriarCalendarioDaAtividade
  >(calendarioRep.criarCalendarioDaAtividade, [])

  const profissional = ref<EntidadeGenerica>()
  const profissionaisSelecionados = ref<string[]>([])
  const profissionais = ref<EntidadeGenerica[]>([])
  const repeticaoSelecionada = ref<string>("nao-repete")
  const atividadeDoProjetoSelecionada = ref<string>("")
  const projetoSelecionado = ref<string>("")
  const projetos = ref<ProjetosComAtividadesDoProjeto[]>([])
  const projetosMapeados = ref<EntidadeGenerica[]>([])
  const atividadesDoProjeto = ref<OpcaoAtividadeDoProjeto[]>([])
  const duracaoEmMinutos = ref(0)
  const diasComAtividade: Ref<number[]> = ref([])
  const etapaAtiva = ref<number>(0)
  const atributosEsperados = ref<AtributoBase[]>([])

  const estagioRequisicao = ref<number>(estados.INICIAL)

  const etapas = <Etapa[]>([
    { rotulo: t('etapaAtividade') },
    { rotulo: t('etapaAtributos') }
  ])

  const regras = {
    periodo: {
      inicio: {
        data: {},
        hora: {},
      },
      fim: {
        data: { required: helpers.withMessage("campo obrigatório*", required) },
        hora: { required: helpers.withMessage("campo obrigatório*", required) },
      },
    },
    repeticao: {},
    tipoDeAtividade: {
      required: helpers.withMessage("campo obrigatório*", required),
    },
    duracaoEmMinutos: {
      required: helpers.withMessage("campo obrigatório*", required),
    },
    diasComAtividade: {
      required: helpers.withMessage(
        "pelo menos um dia deve ser selecionado*",
        and(
          minLength(1),
          requiredIf(() => repeticaoSemanalmenteSelecionada.value)
        )
      ),
    },
    profissionais: {},
    projeto: {
      required: helpers.withMessage("campo obrigatório*", required),
    },
  }

  const v$ = useVuelidate(regras, {
    periodo,
    repeticao: repeticaoSelecionada,
    tipoDeAtividade: atividadeDoProjetoSelecionada,
    duracaoEmMinutos,
    diasComAtividade,
    profissionais: profissionaisSelecionados,
    projeto: projetoSelecionado,
  })

  /* computeds */
  const repeticaoNaoRepeteSelecionada = computed(() => {
    return repeticaoSelecionada.value === "nao-repete"
  })

  const repeticaoSemanalmenteSelecionada = computed(() => {
    return repeticaoSelecionada.value === "semanalmente"
  })

  const estaCarregandoProjetos = computed(() => {
    return lerProjetos.resultado.status === "pendente"
  })

  const ocultarCampoDeProfissionais = computed(() => {
    return verificarPermissao("criar")
  })

  const lancandoAtividade = computed(
    () => estagioRequisicao.value === estados.PEDENTE
  )

  const minDataFim = computed(() => {
    const inicio = v$.value.periodo.inicio.data.$model
    return inicio ?? undefined
  }) as ComputedRef<Date | undefined>

  const maxDataInicio = computed(() => {
    const fim = v$.value.periodo.fim.data.$model
    return fim ?? hoje
  }) as ComputedRef<Date>

  const rotuloBotaoSalvar = computed(() => {
    return props.modo === "editar" && props.idEvento
      ? t('salvarAlteracoes')
      : t('confirmar')
  })

  const temAtributos = computed(() => {
    return atributosEsperados.value && atributosEsperados.value.length > 0 
  })

  const deveExibirEtapas = computed(() => {
    return temAtributos.value
  })

  const estaCarregandoAtributos = computed(() => {
    return (
      atividadeDoProjetoSelecionada.value !== null &&
      lerTiposDeAtividadeComAtributos.resultado.status === 'pendente'
    )
  })

  const desabilitarBotaoSalvarAtividade = computed(() => {
    if (!temAtributos.value) {
      return false
    }
    return caracteristicas.value.every(caracteristica => verificarSeElementoTemConteudo(caracteristica.valor))
  })

  /* métodos */
  const resetarFormulario = () => {
    periodo.inicio.data = pegarDataDeHoje()
    periodo.inicio.hora = pegarDataDeHoje()
    periodo.fim.data = pegarDataDeHoje()
    periodo.fim.hora = adicionarHorasNoMomentoAtual(1)

    profissional.value = undefined
    profissionaisSelecionados.value = []

    projetoSelecionado.value = ""
    atividadeDoProjetoSelecionada.value = ""
    atividadesDoProjeto.value = []
    atributosEsperados.value = []
    etapaAtiva.value = 0
    caracteristicaStore.resetarCaracteristicas()
    v$.value.$reset()
  }

  const mapearProjetos = (): void => {
    projetosMapeados.value = projetos.value.map((projeto) => {
      return {
        id: projeto.id,
        nome: projeto.nomeProjeto,
      }
    })
  }

  const selecionarProjeto = (idProjeto: string): void => {
    projetoSelecionado.value = idProjeto
    atividadeDoProjetoSelecionada.value = ""
    atributosEsperados.value = []
    caracteristicaStore.resetarCaracteristicas()

    const projeto = projetos.value.find(
      (item) => item.id === idProjeto
    )

    atividadesDoProjeto.value = (projeto?.atividadesDoProjeto || [])
      .filter((atividade) => atividade.ativo !== false && Boolean(atividade.id))
      .map((atividade) => ({
        id: atividade.id as string,
        idTipoDeAtividade: atividade.idTipoDeAtividade,
        nome: `${atividade.codigo} - ${atividade.nome}`,
      }))
  }

  const listarAtributosDoTipoDeAtividade = async (): Promise<void> => {
    const atividadeSelecionada = atividadesDoProjeto.value.find(
      (atividade) => atividade.id === atividadeDoProjetoSelecionada.value
    )

    if (!atividadeSelecionada) {
      atributosEsperados.value = []
      caracteristicaStore.resetarCaracteristicas()
      etapaAtiva.value = 0
      return
    }

    caracteristicaStore.resetarCaracteristicas()
    etapaAtiva.value = 0

    lerTiposDeAtividadeComAtributos.sobrescreverParametros({
      id: "igual." + atividadeSelecionada.idTipoDeAtividade,
    })
    await lerTiposDeAtividadeComAtributos.executar()

    if (lerTiposDeAtividadeComAtributos.resultado.status === 'sucesso') {
      atributosEsperados.value = lerTiposDeAtividadeComAtributos.resultado.dados[0]?.atributosEsperados || []
    }

    if (lerTiposDeAtividadeComAtributos.resultado.status === "erro") {
      onErro({
        resumo: t("erroAoBuscarAtributos"),
        detalhes: t("ocorreuUmErroAoBuscarAtributos"),
      })
    }
  }

  const aoClicarNaEtapa = (indice: number) => {
    etapaAtiva.value = indice
  }

  const avancarParaProximaEtapa = (): void => {
    etapaAtiva.value = 1
  }

  const buscarMaisProjetos = async (): Promise<void> => {
    if (!lerProjetos.possuiMaisItensNaProximaPagina()) {
      return
    }

    await lerProjetos.proximoComAcumulo()
    if (lerProjetos.resultado.status === "sucesso") {
      projetos.value = lerProjetos.resultado.dados
      mapearProjetos()
    }
  }

  const listarProjetos = async (): Promise<void> => {
    await lerProjetos.executar()

    if (lerProjetos.resultado.status == "sucesso") {
      projetos.value = lerProjetos.resultado.dados
      mapearProjetos()
    }
  }

  const listarProfissionais = async (idProfissional?: string) => {
    const paramIdProfissional = idProfissional
      ? "igual." + idProfissional
      : undefined

    lerProfissionais.sobrescreverParametros({
      ativo: "igual.true",
      "por-pagina": "1000",
      id: paramIdProfissional,
    })

    await lerProfissionais.executar()
    if (lerProfissionais.resultado.status === "sucesso") {
      await atualizarDadosDoRepositorio(lerProfissionais, profissionais)
    }
  }

  const filtrarProjetos = async (valorInserido: string): Promise<void> => {
    if (valorInserido.length > 0) {
      lerProjetos.incrementarParametros({
        nome_projeto: `contem.${valorInserido}`,
      })
    } else {
      lerProjetos.resetarParametrosParaEstadoInicial()
    }

    await lerProjetos.pagina(0).executar()
    if (lerProjetos.resultado.status === "sucesso") {
      projetos.value = lerProjetos.resultado.dados
    }

    mapearProjetos()
  }

  const fecharModal = () => {
    emissorVisibilidade.value = false
    resetarFormulario()
  }

  const criarEventoPlanejado = async () => {
    estagioRequisicao.value = estados.PEDENTE
    criarAtividadePlanejadaEscritor.mudarArgumentos([montarAtividadePlanejada()])
    await criarAtividadePlanejadaEscritor.executar()

    resolver<{ id: string }>(criarAtividadePlanejadaEscritor.resultado, {
      sucesso: () => {
        onSucesso({
          resumo: t("eventoDaAtividadePlanejadaLancadaComSucesso"),
          detalhes: "",
        })
        emitir("onRecarregarAtividades")
        fecharModal()
        estagioRequisicao.value = estados.SUCESSO
      },
      erro: (erro: EscritorErro) => {
        estagioRequisicao.value = estados.ERRO
        onErro({
          resumo: t("naoFoiPossivelLancarEventoDaAtividadePlanejada"),
          detalhes: erro.mensagem,
        })
      },
    })
  }

  const criarCalendarioDaAtividade = async () => {
    estagioRequisicao.value = estados.PEDENTE
    criarCalendarioDaAtividadeEscritor.mudarArgumentos([
      montarCalendarioDaAtividade(),
    ])
    await criarCalendarioDaAtividadeEscritor.executar()

    resolver<{ id: string }>(criarCalendarioDaAtividadeEscritor.resultado, {
      sucesso: () => {
        onSucesso({
          resumo: t('calendarioDaAtividadeCriadoComSucesso'),
          detalhes: "",
        })
        // Delay para que dê tempo do celery criar pelo menos as atividades da semana atual
        setTimeout(() => {
          emitir("onRecarregarAtividades")
          fecharModal()
          estagioRequisicao.value = estados.SUCESSO
        }, 5000)
      },
      erro: (erro: EscritorErro) => {
        estagioRequisicao.value = estados.ERRO
        onErro({
          resumo: t('naoFoiPossivelCriarCalendarioDaAtividade'),
          detalhes: erro.mensagem,
        })
      },
    })
  }

  const montarAtividadePlanejada = (): CriarAtividadePlanejada => {
    const tipoDeAtividadePossuiAtributos = caracteristicas.value.length > 0

    const atividadePlanejada: CriarAtividadePlanejada = {
      atividadeDoProjetoId: atividadeDoProjetoSelecionada.value,
      dataInicio: pegarSomenteData(periodo.inicio.data),
      horaInicio: pegarSomenteAsHoras(periodo.inicio.hora),
      profissionaisAlocadosId: profissionaisSelecionados.value,
      duracaoEmMinutos: duracaoEmMinutos.value,
      timezoneInicio: obterTimeZoneLocal(),
      timezoneFim: obterTimeZoneLocal(),
    }

    if (tipoDeAtividadePossuiAtributos) {
      atividadePlanejada.listaDeAtributosCaracteristicaComValor = caracteristicas.value.map(caracteristica => ({
        id: caracteristica.id,
        valor: caracteristica.valor,
      }))
    }

    return atividadePlanejada
  }

  const montarCalendarioDaAtividade = (): CriarCalendarioDaAtividade => {
    const totalDeDiasDaSemana = 7

    const formatarDiasComAtividadeParaAPI = (
      listaDeDias: number[]
    ): Record<number, boolean> => {
      return listaDeDias.reduce((acumulador, diaDeAtividade) => {
        acumulador[diaDeAtividade] = true
        return acumulador
      }, {})
    }

    const calendarioDaAtividade: CriarCalendarioDaAtividade = {
      idAtividadeDoProjeto: atividadeDoProjetoSelecionada.value,
      dataInicial: pegarSomenteData(periodo.inicio.data),
      horarioDeInicio: pegarSomenteAsHoras(periodo.inicio.hora),
      dataFinal: pegarSomenteData(periodo.fim.data),
      numeroDeDias: totalDeDiasDaSemana,
      idsProfissionaisAlocados: profissionaisSelecionados.value,
      diasComAtividade: formatarDiasComAtividadeParaAPI(diasComAtividade.value),
      duracaoEmMinutos: duracaoEmMinutos.value,
      timezoneInicio: obterTimeZoneLocal(),
      timezoneFim: obterTimeZoneLocal(),
    }
    return calendarioDaAtividade
  }

  const lancarAtividade = async () => {
    const tipoDeAtividadePossuiAtributos = caracteristicas.value.length > 0

    if (tipoDeAtividadePossuiAtributos) {
      const caracteristicasSemValorPreenchido = caracteristicas.value.every(caracteristica => verificarSeElementoTemConteudo(caracteristica.valor))

      if (caracteristicasSemValorPreenchido) {
        onInfo({
          resumo: t("atributosComValoresInvalidos"),
          detalhes: t("naoPreenchaValores"),
        })
        return
      }
    }

    try {
      if (repeticaoNaoRepeteSelecionada.value) {
        await criarEventoPlanejado()
      }

      if (repeticaoSemanalmenteSelecionada.value) {
        await criarCalendarioDaAtividade()
      }
    } catch (error: any) {
      const erro = error as Erro
      estagioRequisicao.value = estados.ERRO
      onErro({
        resumo: erro.mensagem,
        detalhes: erro.detalhe,
      })
    }
  }

  const definirDiasComAtividade = (listaDeIndices: number[]) => {
    diasComAtividade.value = listaDeIndices
  }

  const onCarregarDados = async (requisicoes: Promise<void>[]) => {
    try {
      await Promise.all(requisicoes)
    } catch (error: any) {
      const erro = error as Erro
      onErro({
        resumo: erro.mensagem,
        detalhes: erro.detalhe,
      })
      estagioRequisicao.value = estados.ERRO
    }
  }
  const carregarDadosModoCriar = async () => {
    await onCarregarDados([
      listarProfissionais(),
      listarProjetos(),
    ])
  }
  onUnmounted(() => {
    caracteristicaStore.resetarCaracteristicas()
  })
  /* provide/injects */
  /* lifecyles */
  onMounted(() => {
    carregarDadosModoCriar()
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: _unref(emissorVisibilidade),
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_isRef(emissorVisibilidade) ? (emissorVisibilidade).value = $event : null)),
    "append-to": __props.destinos,
    class: "OCriarEventoPlanejado",
    "data-testid": "OCriarEventoPlanejado",
    "dismissable-mask": "",
    draggable: false,
    header: "Header",
    modal: true,
    style: { width: '550px' }
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(t)('projetos')), 1),
        _createVNode(_unref(MDropdown), {
          modelValue: _unref(v$).projeto.$model,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).projeto.$model) = $event)),
            selecionarProjeto
          ],
          onOnFiltrandoBusca: filtrarProjetos,
          "buscar-mais-itens": buscarMaisProjetos,
          carregando: _unref(estaCarregandoProjetos),
          class: "OCriarEventoPlanejado__SeletorProjetos",
          "data-testid": "OCriarEventoPlanejado__SeletorProjetos",
          destino: __props.destinos,
          "mensagem-de-erro": _unref(v$).projeto.$errors[0]?.$message,
          nome: "projetos",
          "option-label": "nome",
          "option-value": "id",
          options: projetosMapeados.value,
          placeholder: _unref(t)('projetos'),
          "usar-carregamento-sob-demanda": "",
          width: "480px"
        }, null, 8, ["modelValue", "carregando", "destino", "mensagem-de-erro", "options", "placeholder"]),
        _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(t)('lancarAtividadeDe')), 1),
        _createVNode(_unref(MDropdown), {
          modelValue: _unref(v$).tipoDeAtividade.$model,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).tipoDeAtividade.$model) = $event)),
            listarAtributosDoTipoDeAtividade
          ],
          id: "OCriarEventoPlanejado__SeletorAtividades",
          class: "OCriarEventoPlanejado__SeletorAtividades",
          "data-testid": "OCriarEventoPlanejado__SeletorAtividades",
          destino: __props.destinos,
          "mensagem-de-erro": _unref(v$).tipoDeAtividade.$errors[0]?.$message,
          nome: "lanca-atividade",
          "option-label": "nome",
          "option-value": "id",
          options: atividadesDoProjeto.value,
          width: "480px"
        }, null, 8, ["modelValue", "destino", "mensagem-de-erro", "options"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_14, [
        (_unref(temAtributos) && etapaAtiva.value === 0)
          ? (_openBlock(), _createBlock(_unref(ABotaoDeAcao), {
              key: 0,
              onProximoPasso: avancarParaProximaEtapa,
              "esta-carregando": false,
              "fase-da-atividade": "proximoPasso"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_unref(AButton), {
                onClick: fecharModal,
                class: "OCriarEventoPlanejado__Botao OCriarEventoPlanejado__Submissor p-button-text p-button-danger",
                "data-testid": "OCriarEventoPlanejado__BotaoCancelar",
                disabled: _unref(lancandoAtividade),
                label: _unref(t)('cancelar')
              }, null, 8, ["disabled", "label"]),
              _createVNode(_unref(AButton), {
                onClick: lancarAtividade,
                class: "OCriarEventoPlanejado__Botao p-button-success",
                "data-testid": "OCriarEventoPlanejado__BotaoLancar",
                disabled: _unref(v$).$invalid || _unref(lancandoAtividade) || _unref(desabilitarBotaoSalvarAtividade) || _unref(estaCarregandoAtributos),
                label: _unref(rotuloBotaoSalvar),
                loading: _unref(lancandoAtividade)
              }, null, 8, ["disabled", "label", "loading"])
            ]))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_4, [
        (_unref(estaCarregandoAtributos))
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "2rem",
              width: "50%"
            }))
          : (_unref(deveExibirEtapas))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(AEtapas), {
                  onEtapaClicada: aoClicarNaEtapa,
                  clicavel: "",
                  etapas: _unref(etapas),
                  "indice-ativo": etapaAtiva.value,
                  largura: "50%"
                }, null, 8, ["etapas", "indice-ativo"])
              ]))
            : _createCommentVNode("", true),
        (etapaAtiva.value === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(ocultarCampoDeProfissionais))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_unref(MMultiSelect), {
                      modelValue: _unref(v$).profissionais.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).profissionais.$model) = $event)),
                      class: "OCriarEventoPlanejado__SeletorProfissionais",
                      "data-testid": "OCriarEventoPlanejado__SeletorProfissionais",
                      destino: __props.destinos,
                      "exibicao-de-opcoes": "comma",
                      "legenda-maximo-selecionados": "{0} profissionais selecionados",
                      "maximo-de-legendas-selecionadas": 1,
                      "mensagem-de-erro": _unref(v$).profissionais.$errors[0]?.$message,
                      nome: "profissionais alocados",
                      "option-label": "nome",
                      "option-value": "id",
                      options: profissionais.value,
                      placeholder: _unref(t)('profissionaisQueSeraoAlocados'),
                      width: "480px"
                    }, null, 8, ["modelValue", "destino", "mensagem-de-erro", "options", "placeholder"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_unref(MCalendario), {
                  modelValue: _unref(v$).periodo.inicio.data.$model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).periodo.inicio.data.$model) = $event)),
                  id: "data-inicio",
                  class: "OCriarEventoPlanejado__DataInicio",
                  "data-testid": "OCriarEventoPlanejado__DataInicio",
                  destino: __props.destinos,
                  "mensagem-de-erro": _unref(v$).periodo.inicio.data.$errors[0]?.$message,
                  "min-data": _unref(maxDataInicio),
                  obrigatorio: "",
                  rotulo: _unref(t)('dataDeInicio')
                }, null, 8, ["modelValue", "destino", "mensagem-de-erro", "min-data", "rotulo"]),
                _createVNode(_unref(MCalendario), {
                  modelValue: _unref(v$).periodo.inicio.hora.$model,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).periodo.inicio.hora.$model) = $event)),
                  id: "hora-inicio",
                  class: "OCriarEventoPlanejado__HoraInicio",
                  "data-testid": "OCriarEventoPlanejado__HoraInicio",
                  destino: __props.destinos,
                  "esconder-picker": true,
                  "formato-hora": "24",
                  icon: "pi pi-clock",
                  "mensagem-de-erro": _unref(v$).periodo.inicio.hora.$errors[0]?.$message,
                  "mostrar-horas": false,
                  obrigatorio: "",
                  rotulo: _unref(t)('horarioDeInicio'),
                  "somente-hora": ""
                }, null, 8, ["modelValue", "destino", "mensagem-de-erro", "rotulo"]),
                _createVNode(_unref(MEntradaNumerica), {
                  modelValue: duracaoEmMinutos.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((duracaoEmMinutos).value = $event)),
                  id: "OCriarEventoPlanejado__Duracao",
                  class: "OCriarEventoPlanejado__Duracao",
                  "mensagem-de-erro": _unref(v$).duracaoEmMinutos.$errors[0]?.$message,
                  min: 0,
                  nome: "duracaoEmMinutos",
                  obrigatorio: "",
                  rotulo: _unref(t)('duracaoMinutos')
                }, null, 8, ["modelValue", "mensagem-de-erro", "rotulo"]),
                _createVNode(_unref(MDropdown), {
                  modelValue: _unref(v$).repeticao.$model,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).repeticao.$model) = $event)),
                  class: "OCriarEventoPlanejado__SeletorRepeticao",
                  "data-testid": "OCriarEventoPlanejado__SeletorRepeticao",
                  destino: __props.destinos,
                  filtro: false,
                  "mensagem-de-erro": _unref(v$).repeticao.$errors[0]?.$message,
                  nome: "repetição",
                  "option-label": "nome",
                  "option-value": "id",
                  options: repeticoes,
                  placeholder: _unref(t)('repeticao'),
                  "usar-carregamento-sob-demanda": "",
                  width: "480px"
                }, null, 8, ["modelValue", "destino", "mensagem-de-erro", "placeholder"]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('ate')), 1),
                  _createVNode(_unref(MCalendario), {
                    modelValue: _unref(v$).periodo.fim.data.$model,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(v$).periodo.fim.data.$model) = $event)),
                    id: "data-fim",
                    "data-testid": "OCriarEventoPlanejado__DataFim",
                    desabilitado: _unref(repeticaoNaoRepeteSelecionada),
                    destino: __props.destinos,
                    "mensagem-de-erro": _unref(v$).periodo.fim.data.$errors[0]?.$message,
                    "min-data": _unref(minDataFim),
                    obrigatorio: "",
                    rotulo: _unref(t)('dataDeFim')
                  }, null, 8, ["modelValue", "desabilitado", "destino", "mensagem-de-erro", "min-data", "rotulo"])
                ]),
                (_unref(repeticaoSemanalmenteSelecionada))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_unref(OSeletorSemanal), {
                        onOnMapearDiasSelecionados: definirDiasComAtividade,
                        "data-base": _unref(v$).periodo.inicio.data.$model,
                        "mensagem-de-erro": _unref(v$).diasComAtividade.$errors[0]?.$message,
                        rotulo: _unref(t)('repetirNosDias')
                      }, null, 8, ["data-base", "mensagem-de-erro", "rotulo"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (etapaAtiva.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_unref(MFormularioAtividadeComAtributos), {
                "atributos-esperados": atributosEsperados.value,
                "desabilitar-campos": true,
                "lista-de-atributos-caracteristica-com-valor": __props.listaDeAtributosCaracteristicaComValor
              }, null, 8, ["atributos-esperados", "lista-de-atributos-caracteristica-com-valor"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "append-to"]))
}
}

})